import { connect } from 'react-redux';
import StatisticsByDaySegments from './StatisticsByDaySegments';

const StatisticsByDaySegmentsComponent = connect(
    () => ({}),
    null
)(StatisticsByDaySegments);

export default StatisticsByDaySegmentsComponent;
